// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"374":"514b0b56","536":"ea32cc7f","660":"64961779","926":"586dfff7","970":"20569b85"}[chunkId] + ".chunk.js");